import apiClient from "../../../../services/apiClient";

export class ConversationApiClient {
  async create() {
    const res = await apiClient.post("/conversation/create");
    return res?.data?.conversation_id || null;
  }

  async list() {
    const res = await apiClient.get("/conversation/list");
    return res?.data?.conversations || {};
  }

  async get(conversationId) {
    if (!conversationId) return null;
    const res = await apiClient.get(`/conversation/${encodeURIComponent(conversationId)}`);
    return res?.data || null;
  }

  async delete(conversationId) {
    if (!conversationId) return;
    await apiClient.delete(`/conversation/${encodeURIComponent(conversationId)}`);
  }
}

